import { createI18n } from 'vue-i18n';

import en from './locales/en.json';
import ru from './locales/ru.json';

/**
 * Конфигурация vue-i18n для Интранета.
 *
 * Основная локаль — `ru`. `en` заведён сразу под будущую английскую версию.
 */
export const i18n = createI18n({
  legacy: false,
  globalInjection: true,
  locale: 'ru',
  fallbackLocale: 'ru',
  messages: { ru, en },
});

export type Locale = 'ru' | 'en';
